module.exports = __webpack_public_path__ + "img/state-management.84386efc.svg";